<template>
  <div class="container-fluid">
    <div class="row" v-if="$store.state.loading">
      <div class="col-12">
        <div class="text-center py-3 card card-body">
          <BeatLoader />
        </div>
      </div>
    </div>

    <div class="row g-3" v-else>
      <ProjectSpecsCard />
      <ProjectCard
        v-for="card in cards"
        :key="card.id"
        :id="card.id"
        :emphasis="card.emphasis"
        :additionals="card.additionals"
      />
    </div>
  </div>
</template>
<script>
import ProjectCard from 'components/project/ProjectCard.vue';
import ProjectSpecsCard from 'components/project/ProjectSpecsCard.vue';
import { getRequest } from 'helper/request';
import BeatLoader from 'components/shared/BeatLoader.vue';

export default {
  name: 'ProjectCardsContainer',
  data() {
    return {
      interval: null,
    };
  },
  props: {
    projectPath: String,
    boardPath: String,
  },
  components: {
    ProjectSpecsCard,
    ProjectCard,
    BeatLoader,
  },
  mounted() {
    this.loadProject();
  },
  computed: {
    /* eslint-disable vue/no-side-effects-in-computed-properties */
    cards() {
      return this.$store.state.cards.sort((a, b) => b.priority - a.priority);
    },
  },
  methods: {
    async loadProject() {
      const self = this;
      const { state } = this.$store;

      try {
        const data = await getRequest(this.projectPath);
        state.loggedIn = data.loggedIn;
        state.revisions = data.revisions;
        state.cards = data.cards;
        state.board = data.board;
        state.project = data.project;
        state.loading = false;

        if (data.board?.previewTop) {
          const renderingTop = document.getElementById('preview_top');
          renderingTop.src = data.board.previewTop;
        }

        if (data.board?.previewBottom) {
          const renderingBottom = document.getElementById('preview_bottom');
          renderingBottom.src = data.board?.previewBottom;
        }
      } catch {
        // Might happen, we stop updates below
      }

      if (state.board === null || state.board.processed) {
        window.clearInterval(self.interval);
      } else if (!state.board.processed && !self.interval) {
        self.interval = window.setInterval(self.loadProject, 4000);
      }
    },
  },
};
</script>

<style lang="scss">
</style>
